import { http } from "@shared/utils/request";
import type { FetchListOptions, ListResult } from "@shared/types/list";
import { mapBrandItemToRow, type BrandListApiItem, type BrandRow } from "@app/views/product/brand/config/data";
import { toBrandExportRequestParams, toBrandListRequestParams, type BrandQueryParam } from "@app/views/product/brand/config/filter";

interface BrandListApiData {
    items: BrandListApiItem[];
    total: number;
}

export interface BrandOptionItem {
    id: string;
    corpId: string;
    name: string;
}

interface BrandOptionsData {
    items: BrandOptionItem[];
}

/** 品牌下拉：可按站点筛选；不传 countryCode 时返回当前企业可见品牌（列表筛选用） */
export function fetchBrandOptions(params?: { countryCode?: string }): Promise<BrandOptionsData> {
    const body: Record<string, string> = {};
    if (params?.countryCode) body.countryCode = params.countryCode;
    return http.post<BrandOptionsData>("/customer/brand/options", body);
}

export function fetchBrandList(params: BrandQueryParam, options?: FetchListOptions): Promise<ListResult<BrandRow>> {
    return http.post<BrandListApiData>("/customer/brand/list", toBrandListRequestParams(params), { signal: options?.signal }).then(res => ({
        list: (res.items || []).map(mapBrandItemToRow),
        total: res.total ?? 0,
    }));
}

/** 异步导出品牌列表，进入下载中心 */
export function exportBrandList(params: BrandQueryParam) {
    return http.post<{ taskId: string; downloadTaskId: string }>("/customer/brand/export", toBrandExportRequestParams(params));
}
